var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.fontFamily,attrs:{"id":"app"}},[(!_vm.isLoading && !_vm.updateIsGettingUserInfo)?[_c('router-view')]:_c('PageLoader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }